export default __webpack_public_path__ + "static/media/createAssignTemplate2.78ed6357.gif";